import pic1 from "../../Assets/WorkPics/1.jpg";
import pic2 from "../../Assets/WorkPics/2.jpg";
import pic3 from "../../Assets/WorkPics/3.jpg";
import pic4 from "../../Assets/WorkPics/4.jpg";
import pic5 from "../../Assets/WorkPics/5.jpg";
import pic6 from "../../Assets/WorkPics/6.jpg";
import pic7 from "../../Assets/WorkPics/7.jpg";
import pic8 from "../../Assets/WorkPics/8.jpg";
import pic9 from "../../Assets/WorkPics/9.jpg";
import pic10 from "../../Assets/WorkPics/10.jpg";
import pic11 from "../../Assets/WorkPics/11.jpg";
import pic12 from "../../Assets/WorkPics/12.jpg";
import pic13 from "../../Assets/WorkPics/13.jpg";
import pic14 from "../../Assets/WorkPics/14.jpg";
import pic15 from "../../Assets/WorkPics/15.jpg";
import pic16 from "../../Assets/WorkPics/16.jpg";
import pic17 from "../../Assets/WorkPics/17.jpg";

export const photos = [
    {
        src: pic1,
        width: 3888,
        height: 2592,
    },
    {
        src: pic2,
        width: 720,
        height: 479,
    },
    {
        src: pic3,
        width: 1280,
        height: 859,
    },
    {
        src: pic4,
        width: 3008,
        height: 2000,
    },
    {
        src: pic5,
        width: 3008,
        height: 2000,
    },
    {
        src: pic6,
        width: 3072,
        height: 2304,
    },
    {
        src: pic7,
        width: 3072,
        height: 2304,
    },
    {
        src: pic8,
        width: 3072,
        height: 2304,
    },
    {
        src: pic9,
        width: 2304,
        height: 3072,
    },
    {
        src: pic10,
        width: 3072,
        height: 2304,
    },
    {
        src: pic11,
        width: 3072,
        height: 2304,
    },
    {
        src: pic12,
        width: 4128,
        height: 2322,
    },
    {
        src: pic13,
        width: 4128,
        height: 2322,
    },
    {
        src: pic14,
        width: 653,
        height: 1160,
    },
    {
        src: pic15,
        width: 768,
        height: 1024,
    },
    {
        src: pic16,
        width: 1280,
        height: 854,
    },
    {
        src: pic17,
        width: 854,
        height: 1280,
    },
]

export default photos;
